/* Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. */

import { AngularFireAction, DatabaseSnapshot } from '@angular/fire/compat/database';

import { FancyFirebaseSplitDataList } from '../generics/FancyFirebaseSplitDataList';
import { DefaultSplitDataRenderType } from '@touchplan/common';
import { IOrganizationProjectFields, OrganizationProject } from 'src/app/app-data/models/OrganizationProject';
import { AngularLandConnection, RefOrObservable } from '../base/interfaces';
import { IFancyIdJoin } from '../base/FancyIdJoin';

export class OrganizationProjectList
	extends FancyFirebaseSplitDataList<
		IOrganizationProjectFields,
		DefaultSplitDataRenderType,
		OrganizationProject
	>
	implements IFancyIdJoin
{
	constructor(angularLand: AngularLandConnection, path: RefOrObservable, fancyJoins?: any) {
		//fix any's
		super(angularLand, path, fancyJoins);
	}

	public $$added(action: AngularFireAction<DatabaseSnapshot<any>>) {
		const organizationProject = new OrganizationProject(action.payload.key);
		organizationProject.databaseUpdate(action.payload.val());
		return organizationProject;
	}

	public $$updated(child: OrganizationProject, action: AngularFireAction<DatabaseSnapshot<any>>) {
		super.$$updated(child, action);
	}

	public applyJoinData(baseKey: string, child: OrganizationProject, otherChild: any) {
		switch (baseKey) {
			case 'organizationId':
				child.view.organization = otherChild ? otherChild : null;
				break;
			case 'projectId':
				child.view.project = otherChild ? otherChild : null;
				break;
			default:
				break;
		}
	}

	public getDataForKey(baseKey: string, child: OrganizationProject) {
		return child.view[baseKey];
	}
}
